import { isProduction } from 'endpoints.config';

const LIVE_SUBJECT_SITES = [
  'pe.getset4education.co.uk',
  'music.getset4education.co.uk',
];

// Shared with sites that are not GetSet's, so it is only trusted outside production.
export const PRE_PROD_DOMAIN = 'avamae.co.uk';

const TOKEN_PLACEHOLDER = 'AUTOLOGINTOKEN';

export const withScheme = (url: string) =>
  /^[a-z][a-z0-9+.-]*:/i.test(url) ? url : `https://${url}`;

export const isOnDomain = (hostname: string, domain: string) =>
  hostname === domain || hostname.endsWith(`.${domain}`);

const isSubjectSite = (url: URL, production = isProduction) =>
  url.protocol === 'https:' &&
  (production
    ? LIVE_SUBJECT_SITES.includes(url.host)
    : isOnDomain(url.hostname, PRE_PROD_DOMAIN));

/**
 * The auto-login token signs its holder in as the user, so it only ever goes into a link to a
 * subject site's own autologin page. Any other address gets no link at all.
 */
export const subjectSiteLaunchUrl = (
  redirectUrl: unknown,
  token: string,
  area: unknown,
  production = isProduction
): string | null => {
  if (typeof redirectUrl !== 'string') return null;
  try {
    const target = new URL(withScheme(redirectUrl));
    if (!isSubjectSite(target, production)) return null;
    // The subject sites' routes ignore case, and launch links arrive in lower case.
    if (target.pathname.toLowerCase() !== '/autologin') return null;
    const query = target.search.replace(TOKEN_PLACEHOLDER, () => token);
    return `${target.origin}${target.pathname}${query}&area=${area}`;
  } catch {
    return null;
  }
};
